/** @jsx jsx */
import { jsx } from '@emotion/react'

interface Props {
  alt: string
  src: string
  className?: string
}

const ImageResponsive: React.FC<Props> = ({ src, alt, className }) => {
  return (
    <img
      className={className}
      css={[
        {
          width: '100%',
        },
      ]}
      src={src}
      alt={alt}
    />
  )
}

export default ImageResponsive
